// components/PercentageBars.tsx
import React, { memo } from 'react'
import styles from '../BuySell.module.css'

interface PercentageBarsProps {
  selectedPercentage: number | null
  onPercentageClick: (percent: number) => void
  currency: string
  type: 'amount' | 'total'
}

/**
 * Percentage bars component for quick balance selection
 * Shows 25%, 50%, 75%, 100% options with cumulative highlighting
 */
const PercentageBars = memo(({ 
  selectedPercentage, 
  onPercentageClick, 
  currency, 
  type 
}: PercentageBarsProps) => {
  const percentages = [25, 50, 75, 100]

  return (
    <div className={styles.percentageBars}>
      {percentages.map(percent => (
        <div
          key={percent}
          className={`${styles.percentageBar} ${
            selectedPercentage && percent <= selectedPercentage ? styles.active : ''
          }`}
          onClick={() => onPercentageClick(percent)}
          title={`${percent}% of available ${currency}`}
        >
          <div className={styles.percentageBarFill} />
        </div>
      ))}
    </div>
  )
})

PercentageBars.displayName = 'PercentageBars'

export default PercentageBars